export const navbarItems = ['about', 'portfolio', 'contact']
